export enum StatusFilterEnum {
  ONGOING = 'ONGOING',
  PLANNED = 'PLANNED',
  INSTALLED = 'INSTALLED',
  COMPLETE = 'COMPLETE',
  COMMENTED = 'COMMENTED',
  PLANNED_WITH_DATA = 'PLANNED_WITH_DATA'
}
